"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusDirective = void 0;
const core_1 = require("@angular/core");
let FocusDirective = class FocusDirective {
    constructor(element, renderer) {
        this.element = element;
        this.renderer = renderer;
    }
    ngAfterViewChecked() {
        this.element.nativeElement.focus();
    }
};
exports.FocusDirective = FocusDirective;
__decorate([
    (0, core_1.Input)('focus'),
    __metadata("design:type", core_1.EventEmitter)
], FocusDirective.prototype, "focusEvent", void 0);
exports.FocusDirective = FocusDirective = __decorate([
    (0, core_1.Directive)({
        selector: '[focus]'
    }),
    __param(0, (0, core_1.Inject)(core_1.ElementRef)),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
], FocusDirective);
//# sourceMappingURL=focus.directive.js.map